import { render } from "./BlockSocioTipo.vue?vue&type=template&id=118eaa10"
import script from "./BlockSocioTipo.vue?vue&type=script&lang=js"
export * from "./BlockSocioTipo.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockSocioTipo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "118eaa10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('118eaa10', __exports__)) {
    console.log('reload')
    api.reload('118eaa10', __exports__)
  }
  
  module.hot.accept("./BlockSocioTipo.vue?vue&type=template&id=118eaa10", () => {
    console.log('re-render')
    api.rerender('118eaa10', render)
  })

}


export default __exports__